export function LoadingState() {
  return (
    <div style={{ textAlign: 'center', padding: 'var(--space-xl) 0' }}>
      <div style={{ marginBottom: 'var(--space-lg)' }}>
        <svg
          width="48"
          height="48"
          viewBox="0 0 48 48"
          fill="none"
          className="animate-spin"
          style={{ margin: '0 auto' }}
        >
          <circle
            cx="24"
            cy="24"
            r="20"
            stroke="var(--border)"
            strokeWidth="4"
            fill="none"
          />
          <path
            d="M24 4C35.046 4 44 12.954 44 24"
            stroke="var(--accent)"
            strokeWidth="4"
            strokeLinecap="round"
            fill="none"
          />
        </svg>
      </div>
      <p style={{ color: 'var(--text-muted)', fontSize: '15px' }}>
        Loading file info...
      </p>
    </div>
  )
}
